import { SearchState } from '../../../models';
import { SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchGetter } from '../search.interfaces';

export class ResultsCallbackInfoGetter implements SearchGetter {

  getters = {
    [SEARCH_GETTERS_KEYS.resultsCallbackInfo]: (searchState: SearchState): any[] => {
      return searchState.results
        .filter(result => result.callbackInfo)
        .map(result => Object.assign({}, result.callbackInfo));
    }
  };
}
